export const ConfirmDelete = {
  mounted() {
    this.el.addEventListener('click', e => {
      const message = this.el.getAttribute('data-message') || 'Are you sure?';

      if (!confirm(message)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  },
};
